function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapSmallScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 6.0734,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.2401,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.4068,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5735,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.7403,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.907,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.0737,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.2405,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.4072,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.2408,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.0734,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.2401,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.4068,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5735,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.7403,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.907,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.0737,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.2405,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.4072,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.2408,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 620.4482,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.4068,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5735,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.7403,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.907,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.0737,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.2405,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.4072,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.4068,
    cy: 642.1441,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5735,
    cy: 642.1441,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5735,
    cy: 663.3109,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.7403,
    cy: 642.1441,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.907,
    cy: 642.1441,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.0737,
    cy: 642.1441,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.2405,
    cy: 642.1441,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.4072,
    cy: 642.1441,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 642.1441,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 642.1441,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 642.1441,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 642.1441,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.0737,
    cy: 663.3109,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.2405,
    cy: 663.3109,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.4072,
    cy: 663.3109,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 663.3109,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 663.3109,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 663.3109,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 663.3109,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.2405,
    cy: 684.4776,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.4072,
    cy: 684.4776,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 684.4776,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 684.4776,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 684.4776,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 684.4776,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.4075,
    cy: 684.4776,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.5743,
    cy: 684.4776,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.741,
    cy: 684.4776,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.4072,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.2408,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.4075,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.5743,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.741,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.4072,
    cy: 725.7527,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.2405,
    cy: 725.7527,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 725.7527,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 725.7527,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 725.7527,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 725.7527,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.2408,
    cy: 725.7527,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.4075,
    cy: 725.7527,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.4072,
    cy: 746.9194,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 746.9194,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 746.9194,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 746.9194,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 746.9194,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.2408,
    cy: 746.9194,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.4075,
    cy: 746.9194,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 768.0862,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 768.0862,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 768.0862,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 789.2529,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 789.2529,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 789.2529,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 768.0862,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.2408,
    cy: 768.0862,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 810.4196,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 810.4196,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.4907,
    cy: 831.5863,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.6575,
    cy: 831.5863,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.2408,
    cy: 810.4196,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.4075,
    cy: 768.0862,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.47,
    cy: 852.7531,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 852.7531,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.8035,
    cy: 852.7531,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.9702,
    cy: 852.7531,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.47,
    cy: 873.9198,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 873.9198,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.8035,
    cy: 873.9198,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.9702,
    cy: 873.9198,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.1369,
    cy: 873.9198,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.3037,
    cy: 873.9198,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.47,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.8035,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.9702,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.1369,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.3037,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.4704,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 915.7241,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.8035,
    cy: 915.7241,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.9702,
    cy: 915.7241,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.1369,
    cy: 915.7241,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.3037,
    cy: 915.7241,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 936.8908,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.8035,
    cy: 936.8908,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.9702,
    cy: 936.8908,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.1369,
    cy: 936.8908,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 958.0575,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.8035,
    cy: 958.0575,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.9702,
    cy: 958.0575,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.1369,
    cy: 958.0575,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 979.2243,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.8035,
    cy: 979.2243,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.9702,
    cy: 979.2243,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 1000.391,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.8035,
    cy: 1000.391,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 1021.5577,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.8035,
    cy: 1021.5577,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 1042.7244,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 1063.8912,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.8035,
    cy: 1042.7244,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.9702,
    cy: 1000.391,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.1369,
    cy: 979.2243,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.3037,
    cy: 936.8908,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.4704,
    cy: 915.7241,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.4075,
    cy: 789.2529,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6367,
    cy: 831.5863,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.5743,
    cy: 725.7527,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.2408,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.4075,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.5743,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.9909,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.1576,
    cy: 599.8107,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.9909,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.1576,
    cy: 620.9774,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.9909,
    cy: 641.615,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.1576,
    cy: 641.615,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.9909,
    cy: 662.7817,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.1576,
    cy: 662.7817,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.4072,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.2408,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.4075,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.4072,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5739,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.7406,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.9074,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.0741,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.9036,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.0703,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.237,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.4038,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.5705,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.9036,
    cy: 515.1438,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.0703,
    cy: 515.1438,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.237,
    cy: 515.1438,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.4038,
    cy: 515.1438,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.5705,
    cy: 515.1438,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 599.2815,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 599.2815,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 620.4482,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 599.2815,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 599.2815,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 620.4482,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 620.4482,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 620.4482,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 641.615,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 641.615,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.8874,
    cy: 641.615,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 641.615,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 641.615,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 641.615,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 662.2525,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 662.2525,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.8874,
    cy: 662.2525,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.7207,
    cy: 662.2525,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 662.2525,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 662.2525,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 662.2525,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 683.9484,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 683.9484,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.8874,
    cy: 683.9484,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.7207,
    cy: 683.9484,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.5539,
    cy: 683.9484,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 683.9484,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 683.9484,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 683.9484,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 789.7821,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 789.7821,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.8874,
    cy: 789.7821,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.7207,
    cy: 789.7821,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.5539,
    cy: 789.7821,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.3872,
    cy: 789.7821,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 789.7821,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 789.7821,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 789.7821,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 810.9488,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 810.9488,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.8874,
    cy: 810.9488,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.7207,
    cy: 810.9488,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.5539,
    cy: 810.9488,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.3872,
    cy: 810.9488,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 810.9488,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 810.9488,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 810.9488,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 832.1155,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 832.1155,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.8874,
    cy: 832.1155,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.7207,
    cy: 832.1155,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.5539,
    cy: 832.1155,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.3872,
    cy: 832.1155,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 832.1155,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 832.1155,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 832.1155,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 853.2822,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 853.2822,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.8874,
    cy: 853.2822,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.7207,
    cy: 853.2822,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.5539,
    cy: 853.2822,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 853.2822,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 853.2822,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 853.2822,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 916.2532,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 916.2532,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 916.2532,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 916.2532,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 916.2532,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 937.42,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 937.42,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 937.42,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 937.42,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 958.5867,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 958.5867,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 979.7534,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 979.7534,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 958.5867,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 873.9198,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 873.9198,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 873.9198,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 873.9198,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 873.9198,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 895.0865,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 768.6153,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 768.6153,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.8874,
    cy: 768.6153,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.7207,
    cy: 768.6153,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.5539,
    cy: 768.6153,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 768.6153,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 768.6153,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 768.6153,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 726.2819,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 726.2819,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.8874,
    cy: 726.2819,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.7207,
    cy: 726.2819,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.5539,
    cy: 726.2819,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.7207,
    cy: 747.4486,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.5539,
    cy: 747.4486,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 726.2819,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 726.2819,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 726.2819,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 746.9194,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 746.9194,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 746.9194,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 746.9194,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.721,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.0541,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.8874,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.7207,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.2208,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.3876,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.5543,
    cy: 705.1151,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.9036,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.0703,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.237,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.9036,
    cy: 599.2815,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.0703,
    cy: 599.2815,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.9036,
    cy: 620.4482,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.0703,
    cy: 620.4482,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.0703,
    cy: 641.615,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.237,
    cy: 599.2815,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.4038,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.5705,
    cy: 578.644,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.5705,
    cy: 599.2815,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.7372,
    cy: 599.2815,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.5705,
    cy: 620.4482,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.7372,
    cy: 620.4482,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.9036,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.0703,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.237,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.4038,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.5705,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.2408,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.4075,
    cy: 536.3105,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.5743,
    cy: 557.4772,
    r: 6.6146,
    style: {
      fill: "#004f32"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSmallScreen);
export default __webpack_public_path__ + "static/media/map-small-screen.1a0d4b53f51105b5681c6a09e674a912.svg";
export { ForwardRef as ReactComponent };